<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    

    <g id="Page-offre-/-Nos-paniers" stroke-width="1">
        <g id="V5---desktop" transform="translate(-309.000000, -803.000000)">
            <g id="Group-6" transform="translate(332.000000, 827.000000) rotate(-90.000000) translate(-332.000000, -827.000000) translate(308.000000, 804.000000)">
                <path d="M38.1086089,25.5882076 C39.0324085,24.4027602 39.0285107,22.7544237 38.1086089,21.5915561 C37.5317213,20.8539444 36.6469005,20.4475052 35.6217558,20.4475052 C33.8521142,20.4475052 32.0668811,20.4663219 30.2738522,20.4926651 C28.5120064,20.5227717 26.7501607,20.5302984 25.0000086,20.5077184 C23.2693459,20.4851385 21.5425811,20.4173986 19.8197142,20.2969722 C18.143622,20.1727825 16.4324488,19.9620363 14.7524587,19.6647336 C14.004064,19.5254905 13.2595672,19.612047 12.5969261,19.913113 C12.0356301,20.1614925 11.2833376,20.699648 10.9052424,21.8888588 L10.7999994,22.6716305 C10.7999994,23.1834428 10.9325276,23.6990183 11.1858904,24.158144 C11.6224539,25.0161822 12.390338,25.580681 13.337525,25.7500306 C15.1929201,26.0962566 17.0950899,26.3483994 18.9933618,26.4989324 C20.8643485,26.6532287 22.7275393,26.7435485 24.5946281,26.7774185 C26.4461253,26.8075251 28.3015204,26.8075251 30.1608134,26.7774185 C31.9850254,26.7473118 33.8053395,26.7284952 35.6217558,26.7284952 C36.6507984,26.7284952 37.5317213,26.3220561 38.1086089,25.5882076" id="Fill-1"></path>
                <path d="M44.0274305,35.1411987 C48.1555048,28.0310191 48.7446796,20.1898145 44.49723,12.64102 C41.6437756,7.5777103 37.3424146,4.34965799 32.5519999,2.27200811 C27.2147695,-0.0441867474 21.7466113,-0.0518817469 16.4825463,2.22968562 C15.3157492,2.73755559 14.2221176,3.44549554 13.105381,4.08418051 C7.61026715,7.21604532 3.66318113,11.9907925 1.46821623,18.4661346 C0.470854984,21.4133195 -0.187634488,24.6529143 1.1640018,27.7578466 C3.12791776,32.2632688 5.50772182,36.5301461 8.69234634,40.1467959 C9.40089641,40.9470758 10.2673299,41.7588983 11.183824,42.1090207 C14.3222388,43.2940507 17.4837584,44.4752331 20.6953386,45.2755131 C22.9904247,45.8487905 25.3817812,45.814163 27.1878138,45.998843 C33.9999066,43.6864956 40.1650624,41.7973733 44.0274305,35.1411987 M13.733064,39.2426334 C12.6779405,38.7616959 11.6536235,37.7805835 10.9412227,36.7494536 C7.7219408,32.0978263 4.98016008,27.1307041 3.51685014,21.455642 C2.95463106,19.2702621 3.79410886,17.4273097 4.79532093,15.7536473 C7.42157718,11.3636501 11.0413439,8.25487026 15.4890359,6.56966536 C20.4681405,4.68439047 25.616681,4.226538 30.7382658,6.81975284 C36.603058,9.78617517 41.4858922,13.9337799 43.4344049,21.263267 C43.7463209,22.4329069 43.9889223,23.6948868 43.954265,24.8914593 C43.7270669,33.0597013 39.4026009,39.8890134 32.2285314,41.5357433 C31.5199813,41.7011858 30.8114313,41.8858658 30.3916924,41.9897482 C24.4575855,43.0747432 19.0279355,41.6473208 13.733064,39.2426334" id="Fill-3"></path>
            </g>
        </g>
    </g>

  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    name: {
      type: String,
      required: false,
      default: 'PtcySketchCircledOne',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 46 48',
    },
  },
};
</script>

<style scoped>
  
</style>